<template>
  <v-btn
    :color="color"
    :text="text"
    :outlined="outline"
    :elevation="elevation"
    :depressed="depressed"
    :tile="tile"
    :fab="fab"
    :x-large="xLarge"
    :x-small="xSmall"
    :large="large"
    :small="small"
    :rounded="rounded"
    :disabled="disabled"
    :width="width"
    :icon="icon"
    :loading="loading"
    v-on="btnListeners"
    v-bind="$attrs"
    style="border-radius: 8px !important; min-height: 40px;"
  >
    <slot/>
  </v-btn>
</template>

<script>
import stepUpPrompt from "@/shared/stepUpPrompt";

export default {
  name: "XButton",
  props: {
    color: {
      type: String,
      default: ''
    },
    text: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: String,
      default: '0'
    },
    depressed: {
      type: Boolean,
      default: false
    },
    tile: {
      type: Boolean,
      default: false
    },
    fab: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },

    width: {
      type: String,
      default: ''
    },

    loading: {
      type: Boolean,
      default: false
    },

    // When set (e.g. "totp"), the button requires step-up verification before
    // its click handler runs. Empty string = normal button (unchanged behavior).
    requireVerification: {
      type: String,
      default: ''
    }
  },

  computed: {
    btnListeners() {
      // Unguarded: forward listeners exactly as before (no behavior change).
      if (!this.requireVerification) return this.$listeners;
      // Guarded: intercept click; forward everything else untouched.
      return { ...this.$listeners, click: this.onGuardedClick };
    }
  },

  methods: {
    async onGuardedClick(e) {
      const ok = await stepUpPrompt.ensureVerified(this.requireVerification);
      if (!ok) return;
      const handler = this.$listeners.click;
      if (!handler) return;
      // $listeners.click may be a single fn or an array of fns.
      const handlers = Array.isArray(handler) ? handler : [handler];
      handlers.forEach((h) => h(e));
    }
  }
}
</script>

<style scoped>
v-btn {
  border-radius: 8px !important;
}
</style>
